import React, { Fragment, useEffect, useState } from "react";
import { Layout } from "../../layout/Layout";
import colors from "../../styles/colors";
import BreadCrumbs from "../../components/BreadCrumbs/BreadCrumbs";
import TextEditor from "../../components/TextEditor/TextEditor";
import ContentServices from "../../apis/Content/ContentServices";
import { ErrorToaster, SuccessToaster } from "../../components/Toaster/Toaster";
import { PrimaryButton } from "../../components/Button/Button";
import { Loading } from "../../components/UI/Loader";
import { Box, Grid, Typography } from "@mui/material";

const AboutUs = () => {
  const [loader, setLoader] = useState(true);
  const [content, setContent] = useState("");
  const [contentAr, setContentAr] = useState("");
  const [blogId, setBlogId] = useState("");

  const getTextValue = (value) => setContent(value);
  const getTextArValue = (value) => setContentAr(value);

  const aboutUsContent = async () => {
    try {
      const { data } = await ContentServices.aboutUsContent();
      if (data === null) return;
      setBlogId(data.result._id);
      setContent(data.result.content);
      setContentAr(data.result.content_ar);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  const contentSubmit = async () => {
    try {
      const obj = {
        page_name: "About us",
        content,
        content_ar: contentAr,
      };
      const { data, message } = await ContentServices.createContent(blogId, obj);
      if (data === null) return;
      SuccessToaster(message);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    aboutUsContent();
  }, []);

  return (
    <Fragment>
      <Box
        sx={{
          backgroundColor: colors.lightGray,
          p: { xs: 1.5, sm: 2, md: 3 },
          borderRadius: "12px",
          width: "95%",
          overflowX: "hidden",
        }}
      >
        {/* Header Section */}
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            bgcolor: colors.white,
            p: { xs: 1.5, sm: 2, md: 3 },
            borderRadius: "12px",
            flexDirection: { xs: "column", sm: "row" },
            textAlign: { xs: "center", sm: "left" },
            gap: { xs: 1, sm: 0 },
            width: "100%",
          }}
        >
          <Grid item xs={12} sm={6}>
            <Typography
              variant="h6"
              fontWeight="bold"
              sx={{
                fontSize: { xs: "18px", sm: "20px", md: "22px" },
              }}
            >
              About Us
            </Typography>
          </Grid>

          <Grid
            item
            xs={12}
            sm={6}
            sx={{
              display: "flex",
              justifyContent: { xs: "center", sm: "flex-end" },
              mt: { xs: 1, sm: 0 },
            }}
          >
            <BreadCrumbs currentPage={["About Us"]} />
          </Grid>
        </Grid>

        {/* Content Section */}
        {loader ? (
          <Box sx={{ width: 1, textAlign: "center", pt: 5 }}>
            <Loading />
          </Box>
        ) : (
          <Box
            sx={{
              bgcolor: colors.white,
              p: { xs: 1.5, sm: 2, md: 3 },
              borderRadius: "12px",
              mt: 2,
              width: "100%",
              overflowX: "hidden",
            }}
          >
            <Grid container spacing={3}>
              {/* English Content */}
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: { xs: "14px", sm: "16px" },
                    fontWeight: 500,
                    mb: 1,
                  }}
                >
                  Content
                </Typography>
                <Box
                  sx={{
                    width: "100%",
                    overflow: "hidden",
                    "& .ql-container": {
                      width: "100%",
                      maxWidth: "100%",
                    },
                    "& .ql-editor": {
                      wordBreak: "break-word",
                      fontSize: { xs: "14px", sm: "16px" },
                    },
                  }}
                >
                  <TextEditor getValue={getTextValue} description={content} />
                </Box>
              </Grid>

              {/* Arabic Content */}
              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: { xs: "14px", sm: "16px" },
                    fontWeight: 500,
                    mb: 1,
                  }}
                >
                  Arabic Content
                </Typography>
                <Box
                  sx={{
                    width: "100%",
                    overflow: "hidden",
                    "& .ql-container": {
                      width: "100%",
                      maxWidth: "100%",
                    },
                    "& .ql-editor": {
                      wordBreak: "break-word",
                      fontSize: { xs: "14px", sm: "16px" },
                    },
                  }}
                >
                  <TextEditor
                    getValue={getTextArValue}
                    description={contentAr}
                    type={true}
                  />
                </Box>
              </Grid>
            </Grid>

            {/* Save Button */}
            <Box
              sx={{
                mt: 3,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <PrimaryButton
                data-testId="save-btn"
                title={"Save"}
                onClick={contentSubmit}
              />
            </Box>
          </Box>
        )}
      </Box>
    </Fragment>
  );
};

export default AboutUs;
